import React, { useState } from "react";
import GenericTextField from "../GenericTextField";
import { BRLCurrencyFormat } from "../BRLCurrencyFormat";
import { Check, Clear, Edit } from "@mui/icons-material";
import { Stack } from "@mui/material";
import { BRLCurrencyFixedFormat } from "../BRLCurrencyFixedFormat";

const EditableBRLCurrencyField = ({ value, onSubmit, ...props }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [editText, setEditText] = useState(value);

  const handleEdit = () => {
    setEditText("");
    setIsEditing(true);
  };

  const handleCancelEdit = () => {
    setIsEditing(false);
  };

  const handleChange = (event) => {
    setEditText(event.target.value);
  };

  const handleSubmit = async (event) => {
    const newText = !!editText ? editText : 0;
    setIsSaving(true);
    if (await onSubmit(newText)) {
      setIsEditing(false);
    }
    setIsSaving(false);
  };

  return (
    <div>
      {isSaving 
        ? <div>
            <GenericTextField
                value={'Carregando...'}
                disabled
                variant="standard"
                InputProps={{
                  endAdornment: (
                    <Stack direction={"row"} spacing={2}>
                    </Stack>
                  ),
                }}
                {...props}
              />
          </div>
        : <div>
          {isEditing ? 
            <GenericTextField
              value={editText}
              onChange={handleChange}
              variant="standard"
              autoFocus={true}
              InputProps={{
                inputComponent: BRLCurrencyFormat,
                endAdornment: (
                  <Stack direction={"row"} spacing={2}>
                    <Clear onClick={handleCancelEdit} htmlColor={"#0f2047"} />
                    <Check onClick={handleSubmit} htmlColor={"#0f2047"} />
                  </Stack>
                ),
              }}
              {...props}
            />
           : 
            <GenericTextField
              value={value}
              variant="standard"
              InputProps={{
                inputComponent: BRLCurrencyFixedFormat,
                endAdornment: (
                  <Stack direction={"row"} spacing={2}>
                    <Edit onClick={handleEdit} htmlColor={"#0f2047"} />
                  </Stack>
                ),
              }}
              sx={{
                "& .MuiInputBase-input.Mui-disabled": {
                  WebkitTextFillColor: "#000000",
                },
              }}
              {...props}
              disabled
            />
          }
        </div>
      }
    </div>
  );
};

export default EditableBRLCurrencyField;
